import React from 'react'
import { Helmet } from 'react-helmet-async'

export default function NotFound() {
  return (
    <div>
      <Helmet>
        <title>Page Not Found 404</title>
      </Helmet>
      NotFound
    </div>
  )
}
